var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSatelliteDish(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.144 25.269l1.57-1.57c.392.188.824.301 1.286.301 1.654 0 3-1.346 3-3s-1.344-3-3-3a3 3 0 00-3 3c0 .462.114.894.3 1.285l-1.569 1.57L7.184 16.3a1.06 1.06 0 00-.743-.3.977.977 0 00-.87.494c-2.69 5.021-1.925 11.393 2.305 15.625a13.174 13.174 0 009.356 3.88c2.158 0 4.315-.523 6.263-1.57.588-.323.669-1.145.193-1.612l-7.543-7.548zM19 20a1.003 1.003 0 01.006 2.006A1.003 1.003 0 0119 20zm-1.769 14a11.158 11.158 0 01-7.943-3.29c-3.201-3.203-4.146-7.888-2.538-12.007l14.538 14.544A11.467 11.467 0 0117.23 34zm-.23-30a.996.996 0 00-.995 1c0 .553.444 1 .994 1 9.319 0 17 7.625 17 17 0 .553.448 1.005 1 1.005s1-.455 1-1.005c0-10.475-8.525-19-19-19zm0 6c-.55 0-.995.45-.995 1s.444 1 .994 1c6.063 0 11 4.881 11 11 0 .553.45 1.005 1.002 1.005.553 0 .998-.455.998-1.005 0-7.169-5.831-13-13-13z",
    fill: "#fff"
  })));
}

export default SvgSatelliteDish;